import React from 'react';

import gradientData from "../gradient_collection_resource.json";
// import Particles from "react-particles-js";
import Particles from "react-tsparticles";

const mapStateToProps = (state) => ({
  ...state,
});


class PreviewGallery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        gradients: [ 
          {
            "name": "Ink Purple",
            "color1": "hsla(280, 84%, 41%, 1)",
            "color2": "hsla(218, 97%, 56%, 1)",
            "deg": "180"
        },
        {
          "name": "Oceanic",
          "color1": "hsla(217, 100%, 50%, 1)",
          "color2": "hsla(186, 100%, 69%, 1)",
          "deg": "90"
      },
        {
          "name": "Neon Hallway",
          "color1": "#21D4FD",
          "color2": "#B721FF",
          "deg": "19"
      }],
        image_links: ["svg_waves", "waves_violet", "waves_green", "triangle_background1", "triangle_background2", "triangle_background"],
        //image_links: [],
        particleContainer1: {}, 
        // particlesOptions1: {"background":{"color":{"value":"#0d47a1"},"image":"linear-gradient(19deg, #21D4FD 0%, #B721FF 100%)"},"particles":{"number":{"value":80,"density":{"enable":false}},"size":{"value":3,"random":true,"anim":{"speed":4,"size_min":0.3}},"links":{"enable":false},"move":{"random":true,"speed":1,"direction":"top","out_mode":"out"}},"interactivity":{"events":{"onhover":{"enable":true,"mode":"bubble"},"onclick":{"enable":true,"mode":"repulse"}},"modes":{"bubble":{"distance":250,"duration":2,"size":0,"opacity":0},"repulse":{"distance":400,"duration":4}}}},
        particlesOptions1: {"autoPlay":true,"background":{"color":{"value":"#0d47a1"},"image":"","position":"","repeat":"","size":"","opacity":1},"backgroundMask":{"composite":"destination-out","cover":{"color":{"value":"#fff"},"opacity":1},"enable":false},"backgroundMode":{"enable":true,"zIndex":-1},"detectRetina":true,"infection":{"cure":false,"delay":0,"enable":false,"infections":0,"stages":[]},"interactivity":{"detectsOn":"canvas","events":{"onClick":{"enable":true,"mode":"push"},"onDiv":{"selectors":[],"enable":false,"mode":[],"type":"circle"},"onHover":{"enable":true,"mode":"repulse","parallax":{"enable":false,"force":2,"smooth":10}},"resize":true},"modes":{"attract":{"distance":200,"duration":0.4,"speed":1},"bounce":{"distance":200},"bubble":{"distance":400,"duration":2,"opacity":0.8,"size":40},"connect":{"distance":80,"links":{"opacity":0.5},"radius":60},"grab":{"distance":100,"links":{"blink":false,"consent":false,"opacity":1}},"light":{"area":{"gradient":{"start":{"value":"#ffffff"},"stop":{"value":"#000000"}},"radius":1000},"shadow":{"color":{"value":"#000000"},"length":2000}},"push":{"quantity":4},"remove":{"quantity":2},"repulse":{"distance":200,"duration":0.4,"speed":1},"slow":{"factor":3,"radius":200},"trail":{"delay":1,"quantity":1}}},"manualParticles":[],"motion":{"disable":false,"reduce":{"factor":4,"value":false}},"particles":{"bounce":{"horizontal":{"random":{"enable":false,"minimumValue":0.1},"value":1},"vertical":{"random":{"enable":false,"minimumValue":0.1},"value":1}},"collisions":{"bounce":{"horizontal":{"random":{"enable":false,"minimumValue":0.1},"value":1},"vertical":{"random":{"enable":false,"minimumValue":0.1},"value":1}},"enable":true,"mode":"bounce"},"color":{"value":"#ffffff","animation":{"enable":false,"speed":1,"sync":true}},"life":{"count":0,"delay":{"random":{"enable":false,"minimumValue":0},"value":0,"sync":false},"duration":{"random":{"enable":false,"minimumValue":0.0001},"value":0,"sync":false}},"links":{"blink":false,"color":{"value":"#ffffff"},"consent":false,"distance":150,"enable":true,"frequency":1,"opacity":0.5,"shadow":{"blur":5,"color":{"value":"#00ff00"},"enable":false},"triangles":{"enable":false,"frequency":1},"width":1,"warp":false},"move":{"angle":{"offset":45,"value":90},"attract":{"enable":false,"rotate":{"x":3000,"y":3000}},"direction":"none","distance":0,"enable":true,"gravity":{"acceleration":9.81,"enable":false,"maxSpeed":50},"noise":{"delay":{"random":{"enable":false,"minimumValue":0},"value":0},"enable":false},"outModes":{"default":"bounce","bottom":"bounce","left":"bounce","right":"bounce","top":"bounce"},"random":false,"size":false,"speed":6,"straight":false,"trail":{"enable":false,"length":10,"fillColor":{"value":"#000000"}},"vibrate":false,"warp":false},"number":{"density":{"enable":true,"area":800,"factor":1000},"limit":0,"value":80},"opacity":{"random":{"enable":false,"minimumValue":0.1},"value":0.5,"animation":{"enable":false,"minimumValue":0,"speed":2,"sync":false}},"reduceDuplicates":false,"rotate":{"random":{"enable":false,"minimumValue":0},"value":0,"animation":{"enable":false,"speed":0,"sync":false},"direction":"clockwise","path":false},"shadow":{"blur":0,"color":{"value":"#000000"},"enable":false,"offset":{"x":0,"y":0}},"shape":{"options":{},"type":"square"},"size":{"random":{"enable":true,"minimumValue":1},"value":5,"animation":{"destroy":"none","enable":false,"minimumValue":0,"speed":5,"startValue":"max","sync":false}},"stroke":{"width":0},"twinkle":{"lines":{"enable":false,"frequency":0.05,"opacity":1},"particles":{"enable":false,"frequency":0.05,"opacity":1}}},"pauseOnBlur":true,"pauseOnOutsideViewport":false,"themes":[]},
        particleDetails: [
          {options:  {"background":{"color":{"value":"#0d47a1"},"image":""},"particles":{"number":{"value":80,"density":{"enable":false}},"size":{"value":3,"random":true,"anim":{"speed":4,"size_min":0.3}},"links":{"enable":false},"move":{"random":true,"speed":1,"direction":"top","out_mode":"out"}},"interactivity":{"events":{"onhover":{"enable":true,"mode":"bubble"},"onclick":{"enable":true,"mode":"repulse"}},"modes":{"bubble":{"distance":250,"duration":2,"size":0,"opacity":0},"repulse":{"distance":400,"duration":4}}}},
          gradient: "linear-gradient(19deg, #21D4FD 0%, #B721FF 100%)",
          container: {}},
          {options:  {"background":{"color":{"value":"#0d47a1"},"image":""},"particles":{"number":{"value":80,"density":{"enable":false}},"size":{"value":3,"random":true,"anim":{"speed":4,"size_min":0.3}},"links":{"enable":false},"move":{"random":true,"speed":1,"direction":"top","out_mode":"out"}},"interactivity":{"events":{"onhover":{"enable":true,"mode":"bubble"},"onclick":{"enable":true,"mode":"repulse"}},"modes":{"bubble":{"distance":250,"duration":2,"size":0,"opacity":0},"repulse":{"distance":400,"duration":4}}}},
          gradient: "linear-gradient(45deg, #5757D9 0%, #21D9F7 100%)",
          container: {}},
          {options:  {"background":{"color":{"value":"#0d47a1"},"image":""},"particles":{"number":{"value":80,"density":{"enable":false}},"size":{"value":3,"random":true,"anim":{"speed":4,"size_min":0.3}},"links":{"enable":false},"move":{"random":true,"speed":1,"direction":"top","out_mode":"out"}},"interactivity":{"events":{"onhover":{"enable":true,"mode":"bubble"},"onclick":{"enable":true,"mode":"repulse"}},"modes":{"bubble":{"distance":250,"duration":2,"size":0,"opacity":0},"repulse":{"distance":400,"duration":4}}}},
        gradient: "linear-gradient(90deg, hsla(312, 66%, 76%, 1) 0%, hsla(234, 93%, 67%, 1) 100%)", 
        container: {}},
        ],
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0)

  }

  createParticleElems() {
    var particle_elems = this.state.particleDetails.map((particle, i) => {
      return (
        <article className="flex flex-col h-full" data-aos="zoom-y-out">
        <header>
          {/* <Link to="/app?designType=svgOverlay" className="block mb-6"> */}
            <figure className="relative h-0 pb-9/16 overflow-hidden translate-z-0 rounded">

              {/* <div
              className="gradient absolute inset-0 w-full h-full object-cover transform scale-105 hover:-translate-y-1 transition duration-700 ease-out" 
              // onClick={() => this.handleClick(gradient)}
              style={{
              width: "352",
              height: "198",
              backgroundImage: `linear-gradient(${gradient.deg}deg, ${gradient.color1}, ${gradient.color2})`,
              }}
              /> */}

          {/* <Particles
            id="tsparticles2"
            // init={particlesInit}
            
            // loaded={particlesLoaded}
            // height="100vh"
            // width="100vw"

          //options={{ "background": { "image": " linear-gradient(19deg, #21D4FD 0%, #B721FF 100%)" }, "particles": { "number": { "value": 60, "density": { "enable": true, "value_area": 600 } }, "color": { "value": "#ffffff" }, "shape": { "type": "circle", "stroke": { "width": 0, "color": "#000000" }, "polygon": { "nb_sides": 5 } }, "opacity": { "value": 0.25, "random": true, "anim": { "enable": false, "speed": 1, "opacity_min": 0.1, "sync": false } }, "size": { "value": 9, "random": true, "anim": { "enable": false, "speed": 4, "size_min": 0.1, "sync": false } }, "line_linked": { "enable": false, "distance": 300, "color": "#ffffff", "opacity": 0, "width": 0 }, "move": { "enable": true, "speed": 0.5, "random": true, "direction": "top", "straight": true } }, "interactivity": { "detect_on": "canvas", "events": { "onhover": { "enable": false, "mode": "repulse" }, "onclick": { "enable": false, "mode": "push" }, "resize": true }, "modes": { "grab": { "distance": 800, "line_linked": { "opacity": 1 } }, "bubble": { "distance": 790, "size": 79, "duration": 2, "opacity": 0.8, "speed": 3 }, "repulse": { "distance": 400, "duration": 0.4 }, "push": { "particles_nb": 4 }, "remove": { "particles_nb": 2 } } }, "retina_detect": true
          //}}
            //options={{"autoPlay":true,"background":{"color":{"value":"#567698"},"image":"linear-gradient(180deg, hsla(280, 84%, 41%, 1) 0%, hsla(218, 97%, 56%, 1) 100%)","position":"","repeat":"","size":"","opacity":1},"backgroundMask":{"composite":"destination-out","cover":{"color":{"value":"#fff"},"opacity":1},"enable":false},"backgroundMode":{"enable":false,"zIndex":-1},"detectRetina":true,"infection":{"cure":false,"delay":0,"enable":false,"infections":0,"stages":[]},"interactivity":{"detectsOn":"canvas","events":{"onClick":{"enable":true,"mode":"repulse"},"onDiv":{"selectors":[],"enable":false,"mode":[],"type":"circle"},"onHover":{"enable":true,"mode":"bubble","parallax":{"enable":false,"force":2,"smooth":10}},"resize":true},"modes":{"attract":{"distance":200,"duration":0.4,"speed":1},"bounce":{"distance":200},"bubble":{"distance":250,"duration":2,"opacity":0,"size":0},"connect":{"distance":80,"links":{"opacity":0.5},"radius":60},"grab":{"distance":400,"links":{"blink":false,"consent":false,"opacity":1}},"light":{"area":{"gradient":{"start":{"value":"#ffffff"},"stop":{"value":"#000000"}},"radius":1000},"shadow":{"color":{"value":"#000000"},"length":2000}},"push":{"quantity":4},"remove":{"quantity":2},"repulse":{"distance":400,"duration":0.4,"speed":1},"slow":{"factor":3,"radius":200},"trail":{"delay":1,"quantity":1}}},"manualParticles":[],"motion":{"disable":false,"reduce":{"factor":4,"value":false}},"particles":{"bounce":{"horizontal":{"random":{"enable":false,"minimumValue":0.1},"value":1},"vertical":{"random":{"enable":false,"minimumValue":0.1},"value":1}},"collisions":{"bounce":{"horizontal":{"random":{"enable":false,"minimumValue":0.1},"value":1},"vertical":{"random":{"enable":false,"minimumValue":0.1},"value":1}},"enable":false,"mode":"bounce"},"color":{"value":"#ffffff","animation":{"enable":false,"speed":1,"sync":true}},"life":{"count":0,"delay":{"random":{"enable":false,"minimumValue":0},"value":0,"sync":false},"duration":{"random":{"enable":false,"minimumValue":0.0001},"value":0,"sync":false}},"links":{"blink":false,"color":{"value":"#ffffff"},"consent":false,"distance":150,"enable":false,"frequency":1,"opacity":0.4,"shadow":{"blur":5,"color":{"value":"#00ff00"},"enable":false},"triangles":{"enable":false,"frequency":1},"width":1,"warp":false},"move":{"angle":{"offset":45,"value":90},"attract":{"enable":false,"rotate":{"x":600,"y":600}},"direction":"none","distance":0,"enable":true,"gravity":{"acceleration":9.81,"enable":false,"maxSpeed":50},"noise":{"delay":{"random":{"enable":false,"minimumValue":0},"value":0},"enable":false},"outModes":{"default":"out","bottom":"out","left":"out","right":"out","top":"out"},"random":true,"size":false,"speed":1,"straight":false,"trail":{"enable":false,"length":10,"fillColor":{"value":"#000000"}},"vibrate":false,"warp":false},"number":{"density":{"enable":true,"area":800,"factor":1000},"limit":0,"value":160},"opacity":{"random":{"enable":true,"minimumValue":1},"value":1,"animation":{"enable":true,"minimumValue":0,"speed":1,"sync":false}},"reduceDuplicates":false,"rotate":{"random":{"enable":false,"minimumValue":0},"value":0,"animation":{"enable":false,"speed":0,"sync":false},"direction":"clockwise","path":false},"shadow":{"blur":0,"color":{"value":"#000000"},"enable":false,"offset":{"x":0,"y":0}},"shape":{"options":{"polygon":{"nb_sides":5},"star":{"nb_sides":5},"image":{"src":"https://cdn.matteobruni.it/images/particles/github.svg","width":100,"height":100},"images":{"src":"https://cdn.matteobruni.it/images/particles/github.svg","width":100,"height":100}},"type":"circle"},"size":{"random":{"enable":true,"minimumValue":1},"value":3,"animation":{"destroy":"none","enable":false,"minimumValue":0.3,"speed":4,"startValue":"max","sync":false}},"stroke":{"width":0,"color":{"value":"#000000","animation":{"enable":false,"speed":1,"sync":true}}},"twinkle":{"lines":{"enable":false,"frequency":0.05,"opacity":1},"particles":{"enable":false,"frequency":0.05,"opacity":1}}},"pauseOnBlur":true,"pauseOnOutsideViewport":false,"themes":[]}}

                // container={container1}
                style={{  width:"100%",
                  height: "100%",
                  position: "fixed",
                  zIndex: "-10",
                  top: "0",
                  left: "0"}}
            />  */}

            {/* <Particles particlesRef={particle.container}
            params={particle.options} 
            style={{background: `${particle.gradient}`}}/> */}
              
            </figure>
          {/* </Link> */}
          <div className="mb-3">

          </div>
          <h3 className="text-xl font-bold leading-snug tracking-tight">
            {/* <Link to="/app?designType=svgOverlay" className="hover:underline"></Link> */}
          </h3>
        </header>

      </article>
      )
    }
  )

  return particle_elems;
  }

  createGradientElems() {
    var image_elems = this.state.gradients.map((gradient, i) => {
      return (
          <article className="flex flex-col h-full" data-aos="zoom-y-out">
          <header>
            {/* <Link to="/app?designType=svgOverlay" className="block mb-6"> */}
              <figure className="relative h-0 pb-9/16 overflow-hidden translate-z-0 rounded">

                <div
                className="gradient absolute inset-0 w-full h-full object-cover transform scale-105 hover:-translate-y-1 transition duration-700 ease-out" 
                // onClick={() => this.handleClick(gradient)}
                style={{
                width: "352",
                height: "198",
                backgroundImage: `linear-gradient(${gradient.deg}deg, ${gradient.color1}, ${gradient.color2})`,
                }}
                /> 

                      {/* <img className="absolute inset-0 w-full h-full object-cover transform scale-105 hover:-translate-y-1 transition duration-700 ease-out" 
                      src={require(`../images/${image_link}.PNG`)} width="352" height="198" alt="An example of a background" />
                     */}
                
              </figure>
            {/* </Link> */}
            <div className="mb-3">

            </div>
            <h3 className="text-xl font-bold leading-snug tracking-tight mb-2">
              {/* <Link to="/app?designType=svgOverlay" className="hover:underline"></Link> */}
            </h3>
          </header>

        </article>

      );
    });
    return image_elems;
  }

  createImageElems() {
    var image_elems = this.state.image_links.map((image_link, i) => {
      return (
          <article className="flex flex-col h-full" data-aos="zoom-y-out">
          <header>
            {/* <Link to="/app?designType=svgOverlay" className="block mb-6"> */}
              <figure className="relative h-0 pb-9/16 overflow-hidden translate-z-0 rounded">

                {/* <div
                className="gradient absolute inset-0 w-full h-full object-cover transform scale-105 hover:-translate-y-1 transition duration-700 ease-out" 
                // onClick={() => this.handleClick(gradient)}
                style={{
                width: "352",
                height: "198",
                backgroundImage: `linear-gradient(${gradient.deg}deg, ${gradient.color1}, ${gradient.color2})`,
                }}
                />  */}

                <img className="absolute inset-0 w-full h-full object-cover transform scale-105 hover:-translate-y-1 transition duration-700 ease-out" 
                      src={require(`../../static/img/${image_link}.jpg`)} width="352" height="198" alt="An example of a background" />
                    
              
              </figure>
            {/* </Link> */}
            <div className="mb-3">

            </div>
            <h3 className="text-xl font-bold leading-snug tracking-tight mb-2">
              {/* <Link to="/app?designType=svgOverlay" className="hover:underline"></Link> */}
            </h3>
          </header>

        </article>

      );
    });
    return image_elems;
  }

  render() {


    let gradient_elems = this.createGradientElems();

    let particle_elems = this.createParticleElems();

    let image_elems = this.createImageElems();

    return (
        <div className="flex flex-col min-h-screen overflow-hidden bg-white">                  

        {/*  Page content */}
        <main className="flex-grow">
  
          {/*  Page sections */}
          <section>
            <div className="max-w-6xl mx-auto px-4 sm:px-6">
              <div className="pt-12 pb-2 md:pt-20 md:pb-6">

                {/* Section header */}
                <div className="max-w-3xl mx-auto text-center pb-6 md:pb-12">
                  <h1 className="h1 mb-8 mt-8 text-4xl font-extrabold leading-tight tracking-tighter;" data-aos="zoom-y-out">Examples</h1>
                  <p className="text-xl text-gray-600" data-aos="zoom-y-out" data-aos-delay="150">
                    Here are some examples of the backgrounds you can make!
                    Get over 40 more templates when you gain early access!
                    {/* Click on a background to preview it; it will represent the exported background. */}
                  </p>
                </div>

              </div>
            </div>

            
      <div className="max-w-6xl mx-auto px-4 sm:px-6 bg-grey-600">
        <div className="pb-2 md:pb-4">

          {/* Gradients list */}
          <div className="max-w-sm mx-auto md:max-w-none">

            {/* Gradients container */}
            <div className="grid gap-4 md:gap-12 grid-cols-2 md:grid-cols-3 md:col-gap-6 md:row-gap-8 items-start">

              {/* 1st gradient */}
            {gradient_elems}
            {image_elems}
            {/* {particle_elems} */}
            </div>

          </div>

          <p className="text-xl text-gray-600 text-center" data-aos="zoom-y-out" data-aos-delay="150">
                    ... plus over 40 more templates available and counting!
          </p>

        </div>
      </div>
          </section>
  
        </main>
  
      </div>
    );
  }

}

export default PreviewGallery;